import { useEffect, useRef } from "react"
import { analytics } from "utils/analytics"

const useTrackOnce = (object, action, properties, { ready = true } = {}) => {
  const ref = useRef({ hasTracked: false })
  Object.assign(ref.current, { object, action, properties })

  useEffect(() => {
    if (!ready || ref.current.hasTracked) return
    ref.current.hasTracked = true

    analytics.track(
      ref.current.object,
      ref.current.action,
      ref.current.properties
    )
  }, [ready])
}

export { useTrackOnce }
